module.exports = __webpack_public_path__ + "img/payment-success.a3a7ff97.svg";